import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCategories } from "../lib/categoriesContext";
import { LANG_LABEL } from "../lib/categories";
import { ArticleCard } from "../components/ArticleCard";

export default function Category() {
  const { slug } = useParams();
  const { categories } = useCategories();
  const cat = categories.find((c) => c.slug === slug);
  const [articles, setArticles] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ tag: "", language: "" });

  useEffect(() => {
    setLoading(true);
    const params = { category: slug };
    if (filter.tag) params.tag = filter.tag;
    if (filter.language) params.language = filter.language;
    api.get("/articles", { params }).then((r) => setArticles(r.data)).finally(() => setLoading(false));
  }, [slug, filter.tag, filter.language]);

  useEffect(() => {
    api.get("/tags").then((r) => setTags(r.data)).catch(() => {});
  }, []);

  if (!cat && categories.length > 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-32 text-center">
        <h1 className="font-display text-5xl">Rubrique introuvable</h1>
        <Link to="/" className="font-mono-label text-[#4A7A3D] mt-4 inline-block">← Accueil</Link>
      </div>
    );
  }
  if (!cat) return <div className="py-32 text-center font-mono-label">CHARGEMENT…</div>;

  return (
    <div data-testid="category-page">
      <section className="border-b border-[#E0D8CE] relative">
        <span className="absolute top-0 left-0 w-full h-2" style={{ backgroundColor: cat.accent_color || "#4A7A3D" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="font-mono-label text-[#4A7A3D] mb-3">RUBRIQUE</div>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.98]">{cat.name}</h1>
          <p className="font-quote text-2xl md:text-3xl text-[#4B4B48] mt-5">« {cat.tagline} »</p>
          <p className="mt-6 max-w-2xl text-lg text-[#4B4B48]">{cat.description}</p>
        </div>
      </section>

      <section className="border-b border-[#E0D8CE] bg-[#F5EFEB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center gap-4">
          <span className="font-mono-label text-[#4B4B48]">Langue :</span>
          {["", "fr", "creole", "en"].map((l) => (
            <button key={l || "all"} onClick={() => setFilter({ ...filter, language: l })} className={`font-mono-label px-3 py-1.5 border-2 transition-colors ${filter.language === l ? "bg-[#1A1A18] text-[#FAF8F3] border-[#1A1A18]" : "border-[#E0D8CE] hover:border-[#1A1A18]"}`} data-testid={`category-lang-${l || "all"}`}>
              {l === "" ? "Toutes" : LANG_LABEL[l]}
            </button>
          ))}
          {filter.tag && (
            <button onClick={() => setFilter({ ...filter, tag: "" })} className="font-mono-label px-3 py-1.5 border-2 border-[#4A7A3D] text-[#4A7A3D] hover:bg-[#4A7A3D] hover:text-[#FAF8F3]" data-testid="category-tag-clear">
              #{filter.tag} ✕
            </button>
          )}
        </div>
      </section>

      <section className="border-b border-[#E0D8CE]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {loading ? (
            <p className="font-mono-label text-[#4B4B48]">CHARGEMENT…</p>
          ) : articles.length === 0 ? (
            <div className="py-20 text-center">
              <p className="font-quote text-2xl text-[#4B4B48]">Pas encore d'articles dans cette rubrique.</p>
              <Link to="/" className="font-mono-label text-[#4A7A3D] mt-6 inline-block">← Retour à l'accueil</Link>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
              {articles.map((a) => <ArticleCard key={a.slug} article={a} />)}
            </div>
          )}
        </div>
      </section>

      {tags.length > 0 && (
        <section className="border-b border-[#E0D8CE] bg-[#F5EFEB]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="font-mono-label text-[#4A7A3D] mb-4">Mots-clés populaires</div>
            <div className="flex flex-wrap gap-2">
              {tags.slice(0, 30).map((t) => (
                <button key={t.tag} onClick={() => setFilter({ ...filter, tag: t.tag })} className="bg-[#FAF8F3] border border-[#E0D8CE] px-3 py-1.5 font-mono-label text-[#1A1A18] hover:bg-[#1A1A18] hover:text-[#FAF8F3]" data-testid={`tag-${t.tag}`}>
                  #{t.tag} <span className="opacity-60">({t.count})</span>
                </button>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
